import { render, staticRenderFns } from "./usageDetails.vue?vue&type=template&id=a598716c&"
import script from "./usageDetails.vue?vue&type=script&lang=js&"
export * from "./usageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports